import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProductGrid from '../components/ProductGrid';
import './UserPage.css';
import userPlaceholder from '../assets/usuario.png';

const UserPage = () => {
  const [user, setUser] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { userId } = useParams();

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      setError('');
      try {
        const userPromise = fetch(`https://tech-market-ba-back.vercel.app/users/public/${userId}`);
        const productsPromise = fetch(`https://tech-market-ba-back.vercel.app/products/user/${userId}`);

        const [userResponse, productsResponse] = await Promise.all([userPromise, productsPromise]);

        if (!userResponse.ok) {
          throw new Error('No se pudo encontrar al usuario.');
        }
        const userData = await userResponse.json();
        setUser(userData);

        if (productsResponse.ok) {
          const productsData = await productsResponse.json();
          setProducts(productsData);
        }
        
      } catch (err) {
        console.error("Error al buscar los datos:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [userId]);

  if (loading) {
    return <div className="loading-message">Cargando perfil...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="user-page-container">
      <div className="user-profile-banner">
        <img
          src={user.avatar || userPlaceholder}
          alt={`Perfil de ${user.name}`}
          className="user-avatar"
        />
        <h1 className="user-name">{user.name} <span className="edit-icon">✎</span></h1>
        <p className="user-email">E-Mail: {user.email}</p>
        <p className="user-followers">{user.followers || 0} seguidores</p>
      </div>

      <div className="user-products-section">
        {products.length > 0 ? (
          <ProductGrid title="Productos del usuario" products={products} />
        ) : (
          <>
            <h2 className="section-title">Productos del usuario</h2>
            <p className="no-products-message">Este usuario aun no ha publicado nada</p>
          </>
        )}
      </div>
      
      <button className="back-button" onClick={() => window.history.back()}>
        Volver
      </button>
    </div>
  );
};

export default UserPage;